// This is just an example,
// so you can safely delete all default props below

export default {
    content: 'Innhold',
    new: 'Nytt innhold',
    back: 'Tilbake',
    name: 'Navn',
    start_at: 'Start dato',
    end_at: 'Stopp dato',
    delete: 'Slett',
    save: 'Lagre'
}
